export default __webpack_public_path__ + "static/media/20.ce69e954.png";